var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2397 3.59961C24.9497 2.51961 24.0998 1.65961 23.0298 1.37961C21.0798 0.849608 13.2598 0.849609 13.2598 0.849609C13.2598 0.849609 5.43975 0.849608 3.48975 1.37961C2.40975 1.66961 1.56979 2.51961 1.27979 3.59961C0.759785 5.55961 0.759766 9.65961 0.759766 9.65961C0.759766 9.65961 0.759785 13.7496 1.27979 15.7196C1.56979 16.7996 2.41975 17.6196 3.48975 17.9096C5.43975 18.4396 13.2598 18.4396 13.2598 18.4396C13.2598 18.4396 21.0798 18.4396 23.0298 17.9096C24.1098 17.6196 24.9497 16.7996 25.2397 15.7196C25.7597 13.7596 25.7598 9.65961 25.7598 9.65961C25.7598 9.65961 25.7597 5.56961 25.2397 3.59961ZM10.7097 13.3696V5.93961L17.2397 9.65961L10.7097 13.3796V13.3696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeW);
export default __webpack_public_path__ + "static/media/youtube_w.f5ba1464cf32e8926750b5fc2ff8d8fa.svg";
export { ForwardRef as ReactComponent };